import { showAlert, showLoading, hideLoading } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
/**
 * @description 콜백 함수를 실행하는 동안 로딩을 표시하고, 에러가 발생하면 알림을 표시합니다.
 *
 * @returns {Promise<T | null>} 콜백 함수의 결과 또는 에러 발생 시 null
 */
export async function withLoading(callback) {
    showLoading();
    try {
        const result = await callback();
        return result;
    }
    catch (err) {
        showAlert(getErrorMessage(err), "요청 실패");
        return null;
    }
    finally {
        hideLoading();
    }
}
